import React, { useEffect, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Image, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import MDatePicker from '../../components/MDatePicker';
import Calendar from '../../assets/img/calendar.svg';
import Search from '../../assets/img/search.svg';
import Cancel from '../../assets/img/circleCancel.svg';
import successTick from '../../assets/img/successTick.svg';
import DisablesuccessTick from '../../assets/img/disableSuccess.svg';
import SearchIcon from '@mui/icons-material/Search';
import {
  blankLocation,
  blankLocationData,
  blankSelectedEmployee,
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  SURVEY_TASK_ID,
  TASK_ACTION,
} from '../../utils/Constant';
import {
  ColXsMdType,
  EmployeeNameType,
  MapOptionType,
  MUILocationFilterType,
  PincodeDataType,
  SelectOptionType,
  TaskDetailType,
  TaskItemType,
  TaskLocationDataType,
  TaskNameType,
  TaskStatusType,
} from '../../utils/Types';
import {
  fetchTaskNames,
  fetchEmployeeNames,
  fetchTaskDetails,
  assignTaskToOther,
  fetchStatusDrop,
  taskSelector,
  resetSelectedTask,
  fetchRolesForCustomTask,
} from '../../features/taskSlice';
import { saveCommentNote } from '../../features/onboardingSlice';
import { SelectChangeEvent } from '@mui/material/Select';
import moment from 'moment';
import MAutoComplete from '../../components/MAutoComplete';
import CenterSpinner from '../../components/CenterSpinner';
import { toast } from 'react-toastify';
import { getNoteDate, isAPIFailed, isAPISuccess } from '../../utils/Util';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import MUILocationFilter from '../../components/MUILocationFilter';
import {
  createTask,
  findTaskNameAndSourceOptions,
  findTaskStatusOptions,
  getDefaultLocation,
  getEmployee,
  getEmployeeNameList,
  getLocation,
  onTaskNameChange,
  updateSelectedEmployee,
} from './TaskAssignHelper';
import { useLoader } from '../../loader/LoaderProvider';
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import ImagePreviewModal from '../modals/ImagePreviewModal';
import { loginSelector } from '../../features/loginSlice';
import { LoggedUserType } from '../../utils/Types';
import { ROLE_OMDC } from '../../utils/RBAC';

interface ICreateTaskPageProps {
  title?: string;
  taskToView?: TaskItemType;
  taskStatusName?: string;
  onTaskAction?: (action: string) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const CreateTaskPage: React.FunctionComponent<ICreateTaskPageProps> = ({
  title,
  onTaskAction,
  taskToView,
  taskStatusName,
}) => {
  const [taskAction, setTaskAction] = useState(TASK_ACTION.CREATE);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [selectFilterOther, setSelectFilterOther] = useState<boolean>(false);
  const [taskUniqueId, setTaskUniqueId] = useState('');
  const { showLoader, setShowLoader } = useLoader();
  const [selectedTaskNameId, setSelectedTaskNameId] = useState<number>();
  const [typeOfActivity, setTypeOfActivity] = useState<number | string>();
  const [selectedSource, setSelectedSource] = useState<number>();
  const [taskLinkId, setTaskLinkId] = useState<string>('');
  const [selectedTaskStatus, setSelectedTaskStatus] = useState<number>();
  const [optionTaskName, setOptionTaskName] = useState<SelectOptionType[]>([]);
  const [optionEmployeeName, setOptionEmployeeName] = useState<
    SelectOptionType[]
  >([]);
  const [customTaskName, setCustomTaskName] = useState('');
  const [optionSource, setOptionSource] = useState<SelectOptionType[]>();
  const [locationData, setLocationData] =
    useState<TaskLocationDataType>(blankLocation);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeNameType>(
    blankSelectedEmployee
  );
  const [completionDateTime, setCompletionDateTime] = useState(
    taskToView
      ? moment(taskToView.completedOn).format('DD-MM-YYYY H:mm')
      : moment(new Date()).format('DD-MM-YYYY H:mm')
  );
  const [comment, setComment] = useState<string>();
  const [optionTaskStatus, setOptionTaskStatus] = useState<SelectOptionType[]>([
    { value: 9, label: 'New' },
    { value: 10, label: 'Assigned' },
  ]);
  const [defaultLocationOptions, setDefaultLocationOptions] = useState<any>({});
  const taskToViewDetails = useAppSelector(taskSelector).selectedTask;
  const [openImagePreview, setOpenImagePreview] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');
  const [ifPincode, setIfPincode] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<boolean>(false);
  const taskNameList: TaskNameType[] =
    useAppSelector(taskSelector).taskNameList;
  const customTaskRolesList =
    useAppSelector(taskSelector).rolesListForCustomTask;
  // const IECTaskTypesOption: SelectOptionType[] =
  //   useAppSelector(taskSelector).IECTaskTypes;
  const employeeList: EmployeeNameType[] =
    useAppSelector(taskSelector).employeeList;
  const tasKStatusList: TaskStatusType[] =
    useAppSelector(taskSelector).taskStatusList;
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;

  const [customTaskImages, setCustomTaskImages] = useState<string[]>([]);
  // const [taskDescription, setTaskDescription] = useState<string>('null');
  const [typeOfVisit, setTypeOfVisit] = useState<string>('');
  const [purposeOfVisit, setPurposeOfVisit] = useState<string>('');
  const [outcomeOfVisit, setOutcomeOfVisit] = useState<string>('');
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [availableRoles, setAvailableRoles] = useState<Record<string, string>>(
    {}
  );
  const [disabledRoles, setDisabledRoles] = useState<string[]>([]);
  const [isEmployeeNameDisabled, setIsEmployeeNameDisabled] =
    useState<boolean>(false);
  const [selectedPincodeData, setSelectedPincodeData] = React.useState<any>({
    label: '',
    value: '',
  });
  const [inputValue, setInputValue] = useState('');
  const [pincodeData, setPincodeData] = useState<PincodeDataType[]>([]);

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;

  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const onRoleChange = (key: string, checked: boolean) => {
    let newSelectedRoles = [...selectedRoles];

    if (checked) {
      if (key === '0') {
        // "All" selected
        newSelectedRoles = ['0'];
        setSelectedEmployee(blankSelectedEmployee);
        setIsEmployeeNameDisabled(true);
      } else {
        // Remove "All" if other role selected
        newSelectedRoles = newSelectedRoles.filter((r) => r !== '0');

        if (selectedEmployee?.employeeName) {
          setSelectedEmployee(blankSelectedEmployee);
        }

        if (!newSelectedRoles.includes(key)) newSelectedRoles.push(key);
      }
    } else {
      newSelectedRoles = newSelectedRoles.filter((r) => r !== key);
    }

    setSelectedRoles(newSelectedRoles);
  };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateToViewListPage = () => {
    clearFields();
  };
  const clearFields = () => {
    setTypeOfActivity(undefined);
    setSelectedTaskNameId(undefined);
    setSelectedTaskNameId(undefined);
    setSelectedTaskNameId(undefined);
    setSelectedSource(undefined);
    setSelectedEmployee(blankSelectedEmployee);
    setSelectedTaskStatus(undefined);
    setLocationData(blankLocation);
    setTaskUniqueId(`TAS-O-${moment().format('DDMMYY')}-`);
    setCompletionDateTime(moment().format('DD-MM-YYYY H:mm'));
    setComment('');
    setDefaultLocationOptions({});
    setTaskLinkId('');
    setPincodeData([]);
    setIfPincode(false);
    setInputValue('');
  };
  const setTaskViewData = (taskDetails?: TaskDetailType) => {
    if (taskDetails) {
      setOptionTaskName([
        { value: taskDetails.taskNameId, label: taskDetails.taskName },
      ]);
      setOptionSource([
        {
          value: taskDetails.taskSourceId,
          label: taskDetails.sourceName,
        },
      ]);
      setSelectedTaskNameId(taskDetails.taskNameId);
      setSelectedSource(taskDetails.taskSourceId);
      setSelectedEmployee(getEmployee(taskDetails));
      setCustomTaskName(taskDetails.customTaskName ?? '');
      if (taskDetails?.taskNameId && taskDetails?.taskNameId == 13) {
        setLocationData({
          ...locationData,
          zone: taskDetails?.zone ?? 'All',
          state: taskDetails?.state ?? 'All',
          city: taskDetails?.city ?? 'All',
          district: taskDetails?.district ?? 'All',
          pincode: taskDetails?.pincode ?? 'All',
        });
      } else {
        setLocationData(getLocation(taskDetails));
      }
      setCustomTaskImages(taskDetails.photoUrls ?? []);
      // setTaskDescription('null');
      setTypeOfVisit(taskDetails.typeOfVisit);
      setPurposeOfVisit(taskDetails.purposeOfVisit);
      setOutcomeOfVisit(taskDetails.outcomeOfVisit);
      if (taskDetails?.taskNameId && taskDetails?.taskNameId == 13) {
        if (
          taskDetails?.zone &&
          taskDetails?.state &&
          taskDetails?.district &&
          taskDetails?.city
        ) {
          setDefaultLocationOptions(getDefaultLocation(taskDetails));
        } else {
          setDefaultLocationOptions({
            zoneOption: [
              {
                value: taskDetails?.zone ? taskDetails.zone : 'All',
                label: taskDetails?.zoneName ? taskDetails.zoneName : 'All',
              },
            ],
            stateOption: [
              {
                value: taskDetails?.state ? taskDetails.state : 'All',
                label: taskDetails?.stateName ? taskDetails.stateName : 'All',
              },
            ],
            districtOption: [
              {
                value: taskDetails?.district ? taskDetails.district : 'All',
                label: taskDetails?.districtName
                  ? taskDetails.districtName
                  : 'All',
              },
            ],
            cityOption: [
              {
                value: taskDetails?.city ? taskDetails.city : 'All',
                label: taskDetails?.locationName
                  ? taskDetails.locationName
                  : taskDetails?.cityName
                    ? taskDetails?.cityName
                    : 'All',
              },
            ],
          });
        }
      } else {
        setDefaultLocationOptions(getDefaultLocation(taskDetails));
      }
      setSelectedTaskStatus(taskDetails.taskStatus);
      setTaskUniqueId(taskDetails.taskId);
      setTaskLinkId(taskDetails?.taskLinkId);
      setCompletionDateTime(
        moment.utc(taskDetails.completedOn).local().format('DD-MM-YYYY H:mm')
      );
      setTypeOfActivity(taskDetails?.type_of_activity);
    } else {
      clearFields();
    }
  };
  const findSelectedTaskDetails = (taskId?: string) => {
    try {
      if (!taskId) {
        dispatch(resetSelectedTask());
        setTaskViewData();
        return;
      }
      setShowLoader(true);
      dispatch(fetchTaskDetails({ taskId }))
        .unwrap()
        .then(() => {
          setShowLoader(false);
        })
        .catch(() => {
          setShowLoader(false);
        });
    } catch (err) {}
  };
  const assignTask = () => {
    const data = {
      taskId: taskUniqueId,
      assignedToId: selectedEmployee.candidateId || null,
    };
    setShowLoader(true);
    dispatch(assignTaskToOther(data))
      .unwrap()
      .then((fulfilled: any) => {
        if (isAPIFailed(fulfilled)) {
          toast.error(fulfilled.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled)) {
          findSelectedTaskDetails(taskUniqueId);
          toast.success(fulfilled.responseInformation.responseMessage);
        }
        setShowLoader(false);
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  //Removing this from below method -  dispatch(fetchIECTaskTypes());
  const fetchTaskNamesAndEmployeeNames = () => {
    dispatch(fetchTaskNames());
    dispatch(fetchEmployeeNames());
    dispatch(fetchStatusDrop({ module: 3 }));
  };

  useEffect(() => {
    setTaskAction(taskStatusName ?? TASK_ACTION.CREATE);
    if (taskStatusName && taskStatusName === TASK_ACTION.VIEW) {
      setDisabled(true);
    } else if (!taskStatusName || taskStatusName === TASK_ACTION.CREATE) {
      // Pending Impl
    }
    fetchTaskNamesAndEmployeeNames();
  }, [taskStatusName]);

  const saveComment = () => {
    if (comment && taskToViewDetails) {
      const data = {
        notesDescription: comment,
        module: 2, // 1 - REGISTRATION, 2 - TASK_ASSIGNMENT
        referenceId: taskToViewDetails?.taskAssignmentId, // for REGISTRATION - candidate_id, for TASK_ASSIGNMENT : task_assignment_id
      };
      setShowLoader(true);
      dispatch(saveCommentNote(data))
        .unwrap()
        .then((fulfilled: any) => {
          if (isAPIFailed(fulfilled)) {
            toast.error(fulfilled?.responseInformation.responseMessage);
          } else if (isAPISuccess(fulfilled)) {
            toast.success(fulfilled?.responseInformation.responseMessage);
          }
          setShowLoader(false);
          findSelectedTaskDetails(taskUniqueId);
        })
        .catch(() => {
          toast.error('Comment add failed!');
          setShowLoader(false);
        });
      setComment('');
    }
  };

  useEffect(() => {
    const data = findTaskNameAndSourceOptions(taskNameList, TASK_ACTION.CREATE);
    setOptionTaskName(data.taskNames);
    setOptionSource(data.source);
  }, [taskNameList]);
  useEffect(() => {
    setOptionEmployeeName(getEmployeeNameList(employeeList));
  }, [employeeList]);
  useEffect(() => {
    const array = findTaskStatusOptions(tasKStatusList);
    if (array?.length) {
      setOptionTaskStatus(array);
    }
  }, [tasKStatusList]);
  useEffect(() => {
    setTaskViewData(taskToViewDetails);
  }, [taskToViewDetails]);
  useEffect(() => {
    findSelectedTaskDetails(taskToView?.taskId);
  }, [taskToView]);
  useEffect(() => {
    dispatch(fetchRolesForCustomTask());
  }, []);

  useEffect(() => {
    if (customTaskRolesList && Object.keys(customTaskRolesList).length) {
      setAvailableRoles(customTaskRolesList);
    }
  }, [customTaskRolesList]);

  const initializeLocationData = async () => {
    const noTaskId = !taskToViewDetails?.taskId?.length;
    const isCustomTask = selectedTaskNameId === 13;
    if (noTaskId) {
      if (isCustomTask) {
        if (zoneOption && zoneOption.length === 1) {
          const zoneValue = zoneOption[0].value;
          const stateArray = allStates[zoneValue];
          setSelectFilterOther(true);
          setLocationData({
            ...locationData,
            zone: zoneValue,
            state:
              stateArray.length === 1
                ? stateArray[0].value
                : DEFAULT_OPTION_LOCATION_SET_TARGET.value,
            city: ROLE_OMDC?.includes(loggedUser?.roleId) ? '' : 'All',
            district: ROLE_OMDC?.includes(loggedUser?.roleId) ? '' : 'All',
          });
        } else {
          setSelectFilterOther(true);
          if (ROLE_OMDC?.includes(loggedUser?.roleId)) {
            setLocationData(blankLocation);
          } else {
            setLocationData(blankLocationData);
          }
        }
      } else {
        setSelectFilterOther(false);
        setLocationData(blankLocation);
      }
      setInputValue('');
      setPincodeData([]);
    }
  };

  useEffect(() => {
    initializeLocationData();
  }, [selectedTaskNameId]);

  const mdColSize = taskToView ? 3 : 4;

  const disableEmployeeForSurvey =
    SURVEY_TASK_ID === selectedTaskNameId && taskAction !== TASK_ACTION.CREATE;

  useEffect(() => {
    const hasAll = selectedRoles.includes('0');
    const hasEmployee = !!selectedEmployee?.employeeName;
    const hasPOSP = selectedRoles.includes('7');
    const hasPOSPM = selectedRoles.includes('6');
    const hasSH = selectedRoles.includes('5');

    if (hasAll) {
      setIsEmployeeNameDisabled(true);
      setDisabledRoles(['5', '6', '7']);
    } else if (hasEmployee) {
      setIsEmployeeNameDisabled(false);
      setDisabledRoles(['0', '5', '6', '7']);
      if (selectedRoles.length > 0) setSelectedRoles([]);
    } else if (hasPOSP || hasPOSPM || hasSH) {
      setIsEmployeeNameDisabled(true);
      setDisabledRoles(['0']);
    } else {
      setIsEmployeeNameDisabled(false);
      setDisabledRoles([]);
    }
  }, [selectedRoles, selectedEmployee]);

  const handleSelectedImage = (image: any) => {
    setSelectedImageUrl(image);
    setOpenImagePreview(true);
  };
  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };
  const toggleImageModal = () => {
    setOpenImagePreview(false);
    setSelectedImageUrl('');
  };

  const zoneValRequired =
    selectedTaskNameId &&
    selectedTaskNameId === 13 &&
    !ROLE_OMDC?.includes(loggedUser?.roleId) &&
    ((selectedRoles?.length === 1 &&
      (selectedRoles?.includes('7') ||
        selectedRoles?.includes('6') ||
        selectedRoles?.includes('5'))) ||
      (selectedRoles?.length === 2 &&
        selectedRoles?.includes('7') &&
        selectedRoles?.includes('6')) ||
      (selectedRoles?.length === 2 &&
        selectedRoles?.includes('5') &&
        selectedRoles?.includes('6')) ||
      (selectedRoles?.length === 2 &&
        selectedRoles?.includes('5') &&
        selectedRoles?.includes('7')))
      ? true
      : false;

  const stateValRequired =
    selectedTaskNameId &&
    selectedTaskNameId === 13 &&
    !ROLE_OMDC?.includes(loggedUser?.roleId) &&
    ((selectedRoles?.length === 1 &&
      (selectedRoles?.includes('7') || selectedRoles?.includes('6'))) ||
      (selectedRoles?.length === 2 &&
        selectedRoles?.includes('7') &&
        selectedRoles?.includes('6')))
      ? true
      : false;

  const districtValRequired =
    selectedTaskNameId &&
    selectedTaskNameId === 13 &&
    !ROLE_OMDC?.includes(loggedUser?.roleId) &&
    selectedRoles?.length === 1 &&
    selectedRoles?.includes('7')
      ? true
      : false;

  return (
    <div>
      <Label className="text-heading">{title ?? 'Create Task'}</Label>
      <div className="container-parent task-item-parent-view">
        <Row className="task-details pb-2">
          <Col xs={12} md={mdColSize} className="col-margin">
            <MTextField
              label="Task Id"
              value={taskUniqueId}
              onChange={(event) => {
                setTaskUniqueId(event.target.value);
              }}
              disabled
            />
          </Col>
          <Col xs={12} md={mdColSize} className="col-margin">
            <MSelect
              label="Task Name"
              disabled={disabled}
              options={optionTaskName}
              value={selectedTaskNameId}
              onChange={(e: SelectChangeEvent) => {
                if (selectedTaskNameId != 13) {
                  setCustomTaskName('');
                  setSelectedRoles([]);
                }
                onTaskNameChange(
                  e,
                  taskNameList,
                  setSelectedTaskNameId,
                  setSelectedSource
                );
              }}
              required
            />
          </Col>
          {selectedTaskNameId && selectedTaskNameId === 13 && (
            <Col xs={12} md={mdColSize} className="col-margin">
              <MTextField
                label="Enter Custom/Bulk Task Name"
                value={customTaskName}
                onChange={(event: any) => {
                  setCustomTaskName(event.target.value);
                }}
                disabled={disabled}
                maxLength={50}
                required
              />
            </Col>
          )}
          <Col
            xs={12}
            md={mdColSize}
            className={
              selectedTaskNameId &&
              selectedTaskNameId === 13 &&
              !taskToViewDetails?.taskId?.length
                ? 'col-margin pt-3'
                : 'col-margin'
            }
          >
            <MSelect
              label="Task Type"
              disabled
              value={selectedSource}
              options={optionSource}
              required
            />
          </Col>
          {taskToView && taskLinkId && (
            <Col xs={12} md={mdColSize} className="col-margin">
              <MTextField label="Task Link Id" value={taskLinkId} disabled />
            </Col>
          )}
        </Row>
        <div className="inner-div">
          <Label className="header-style">Assigned To</Label>
          <Row className="mt-1">
            <Col
              xs={!taskAction || taskAction === TASK_ACTION.CREATE ? 12 : 7}
              md={4}
            >
              <MAutoComplete
                label="Employee Name"
                options={optionEmployeeName}
                value={{
                  value: selectedEmployee.candidateId ?? '',
                  label: selectedEmployee.employeeName ?? '',
                }}
                onChange={(value: any) => {
                  updateSelectedEmployee(
                    value,
                    employeeList,
                    setSelectedEmployee
                  );
                  if (value?.employeeName) {
                    setSelectedRoles([]);
                    setIsEmployeeNameDisabled(false);
                  }
                }}
                icon={<Image src={Search}></Image>}
                disabled={
                  selectedTaskNameId && selectedTaskNameId === 13
                    ? disableEmployeeForSurvey || isEmployeeNameDisabled
                    : disableEmployeeForSurvey
                }
              />
            </Col>
            {selectedTaskNameId &&
              selectedTaskNameId === 13 &&
              !taskToViewDetails?.taskId?.length && (
                <Col
                  xs={!taskAction || taskAction === TASK_ACTION.CREATE ? 12 : 7}
                  md={6}
                  className="col-margin"
                >
                  <div className="d-flex align-items-center flex-nowrap">
                    {availableRoles &&
                      Object.keys(availableRoles).length > 0 &&
                      Object.entries(availableRoles)
                        .filter(([key, label]) => label !== null)
                        .map(([key, label]) => (
                          <div className="d-inline-block mr-2" key={key}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedRoles.includes(key)}
                                  onChange={(e) =>
                                    onRoleChange(key, e.target.checked)
                                  }
                                  disabled={disabledRoles.includes(key)}
                                />
                              }
                              label={
                                <span style={{ fontSize: '12px' }}>
                                  {label === 'All'
                                    ? 'All Employees'
                                    : label === 'posp'
                                      ? 'All POSP'
                                      : label === 'pospm'
                                        ? 'All POSPM'
                                        : label === 'State head'
                                          ? 'All SH'
                                          : label}
                                </span>
                              }
                            />
                          </div>
                        ))}
                  </div>
                </Col>
              )}
            {taskAction !== TASK_ACTION.CREATE && (
              <Col xs={4} md={4}>
                <Button
                  variant="primary"
                  className={
                    selectedTaskNameId && selectedTaskNameId === 13
                      ? 'cl-btn-primary-custom me-4 assign-button'
                      : 'cl-btn-primary-custom mt-2 assign-button'
                  }
                  disabled={
                    showLoader ||
                    disableEmployeeForSurvey ||
                    !selectedEmployee?.candidateId ||
                    selectedEmployee?.candidateId ===
                      taskToViewDetails?.assignedToId
                  }
                  onClick={() => {
                    assignTask();
                  }}
                >
                  Assign Task
                </Button>
              </Col>
            )}
          </Row>
          <Row className="mt-3">
            <Col xs={12} md={4}>
              <MTextField
                label="Role"
                value={selectedEmployee?.roleName}
                onChange={(event: any) => {
                  setSelectedEmployee({
                    ...selectedEmployee,
                    roleName: event.target.value,
                  });
                }}
                disabled
              />
            </Col>
            <Col xs={12} md={4} className="col-margin">
              <MTextField
                label="Employee Id"
                value={selectedEmployee?.employeeUniqueId}
                onChange={(event: any) => {
                  setSelectedEmployee({
                    ...selectedEmployee,
                    employeeUniqueId: event.target.value,
                  });
                }}
                disabled
              />
            </Col>
            <Col xs={12} md={4} className="col-margin">
              <MTextField
                label="Mobile Number"
                value={selectedEmployee?.mobileNumber}
                numberOnly
                onChange={(event: any) => {
                  if (event.target.value.length <= 10) {
                    setSelectedEmployee({
                      ...selectedEmployee,
                      mobileNumber: event.target.value,
                    });
                  }
                }}
                disabled
              />
            </Col>
          </Row>
        </div>
        <div className=" inner-div">
          <Label className="header-style">Location Details</Label>

          <Row className="mb-3 mt-2">
            <Col xs={12} md={5}>
              {!taskToViewDetails?.taskId?.length ? (
                <Autocomplete
                  open={ifPincode}
                  onOpen={() => setIfPincode(true)}
                  onClose={() => setIfPincode(false)}
                  options={pincodeData}
                  getOptionLabel={(option) => String(option?.label)}
                  value={selectedPincodeData ?? null}
                  inputValue={inputValue}
                  onInputChange={(event, newValue, reason) => {
                    if (reason !== 'reset') {
                      const safeValue =
                        typeof newValue === 'string' ? newValue : '';
                      console.log('safeValue', safeValue);
                      setInputValue(safeValue);
                    }
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={async (event, newValue) => {
                    console.log('newValue', newValue);
                    if (newValue) {
                      const validZoneIds =
                        (await zoneOption.map((zone) => zone.value)) || [];
                      const validStateIds =
                        (await Object.values(allStates).flatMap((group) =>
                          group.map((item) => item.value)
                        )) || [];
                      if (
                        !validZoneIds.includes(String(newValue.zoneId)) ||
                        !validStateIds.includes(String(newValue.stateId))
                      ) {
                        alert(
                          'This location isn’t within your assigned region'
                        );
                        setInputValue('');
                        setPincodeData([]);
                        initializeLocationData();
                        return;
                      }
                      setSearchTerm(true);
                      setSelectedPincodeData(newValue);
                      setLocationData({
                        ...locationData,
                        zone: newValue.zoneId,
                        state: newValue.stateId,
                        district: newValue.districtId,
                        city: newValue.villageId,
                        pincode: newValue.pincode,
                      });
                    } else {
                      setPincodeData([]);
                      initializeLocationData();
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pincode"
                      InputLabelProps={{
                        style: { fontSize: '0.8rem' },
                      }}
                      error={
                        inputValue !== '' &&
                        (!/^\d{6}$/.test(inputValue) ||
                          Number(inputValue) < 100001 ||
                          Number(inputValue) > 999999)
                      }
                      helperText={
                        inputValue !== '' &&
                        (!/^\d{6}$/.test(inputValue) ||
                          Number(inputValue) < 100001 ||
                          Number(inputValue) > 999999)
                          ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                          : ''
                      }
                      variant="outlined"
                      id="searchPincode"
                      required={
                        selectedTaskNameId &&
                        selectedTaskNameId === 13 &&
                        !ROLE_OMDC?.includes(loggedUser?.roleId)
                          ? selectedEmployee?.employeeName?.length
                            ? true
                            : false
                          : true
                      }
                      // value={searchTerm ?? ''}
                      // onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <InputAdornment position="end">
                              <IconButton onClick={handleSearchClick}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                  )}
                />
              ) : (
                <MTextField
                  label="Pincode"
                  required={
                    selectedTaskNameId && selectedTaskNameId === 13
                      ? false
                      : true
                  }
                  value={locationData.pincode ?? ''}
                  numberOnly
                  onChange={(data: any) => {
                    const numberRegex = /^\d*$/;
                    if (
                      data.target.value.length <= 6 &&
                      numberRegex.test(data.target.value)
                    ) {
                      // pending Impl
                    }
                  }}
                  disabled
                />
              )}
            </Col>
          </Row>

          <MUILocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: locationData.zone,
              state: locationData.state,
              district: locationData.district,
              city: locationData.city,
            }}
            setLocationFilter={(filter: MUILocationFilterType) => {
              setLocationData({
                ...locationData,
                zone: filter.zone,
                state: filter.state,
                district: filter.district,
                city: filter.city,
                pincode: filter.pincode ?? '',
              });
            }}
            disabled={disabled}
            required={
              selectedTaskNameId &&
              selectedTaskNameId === 13 &&
              !ROLE_OMDC?.includes(loggedUser?.roleId)
                ? selectedEmployee?.employeeName?.length
                  ? true
                  : false
                : true
            }
            zoneRequired={zoneValRequired}
            stateRequired={stateValRequired}
            districtRequired={districtValRequired}
            defaultLocationOptions={defaultLocationOptions}
            includeAllOption={
              selectedTaskNameId &&
              selectedTaskNameId === 13 &&
              !ROLE_OMDC?.includes(loggedUser?.roleId)
                ? true
                : false
            }
            selectFilterOther={selectFilterOther}
            setInputValue={(data: any) => {
              setInputValue(String(data));
            }}
            searchTerm={searchTerm}
            setSearchTerm={(data: any) => {
              setSearchTerm(data);
            }}
          />
        </div>
        <div className="inner-div">
          <Label className="header-style">Others</Label>
          <Row className="mt-1">
            {/* selectedTaskNameId === TASK_IEC ? 4 : 6 */}
            <Col xs={12} md={6} className="task-date-picker">
              <MDatePicker
                label="Completion Date & Time"
                value={completionDateTime}
                onChange={setCompletionDateTime}
                disabled={disabled}
                icon={<Image src={Calendar}></Image>}
                haveMinDate={true}
                minDate={moment()}
                maxDate={moment().add(89, 'days')}
              />
            </Col>
            {/* {selectedTaskNameId === TASK_IEC && (
              <Col xs={12} md={4} className="col-margin">
                <MSelect
                  label="Type of Activity"
                  required
                  options={IECTaskTypesOption}
                  onChange={(event: any) => {
                    setTypeOfActivity(event.target.value);
                  }}
                  value={typeOfActivity}
                />
              </Col>
            )} */}

            <Col xs={12} md={6} className="col-margin">
              <MSelect
                label="Status of Task"
                disabled
                options={optionTaskStatus}
                onChange={(event: any) => {
                  setSelectedTaskStatus(event.target.value);
                }}
                value={
                  taskAction === TASK_ACTION.CREATE
                    ? optionTaskStatus[0].value
                    : selectedTaskStatus
                }
              />
            </Col>
          </Row>
        </div>

        {taskToViewDetails?.taskId?.length &&
        selectedTaskNameId &&
        selectedTaskNameId === 13 &&
        (customTaskImages?.length ||
          typeOfVisit?.length ||
          purposeOfVisit?.length ||
          outcomeOfVisit?.length) ? (
          <div className="inner-div">
            {customTaskImages && customTaskImages.length ? (
              <Row className="mt-2">
                <Label for="images" className="header-style">
                  Images
                </Label>
                {customTaskImages.map((image: any, index: number) => (
                  <Col
                    xs={12}
                    md={6}
                    xl={3}
                    key={`key-${String(index)}}`}
                    className="mt-3"
                  >
                    <Image
                      src={image}
                      width={'100%'}
                      height={'200px'}
                      className="activityImage"
                      alt="activity image"
                      onClick={() => handleSelectedImage(image)}
                    />
                  </Col>
                ))}
              </Row>
            ) : null}

            {typeOfVisit?.length ||
            purposeOfVisit?.length ||
            outcomeOfVisit?.length ? (
              <Row className="mt-2">
                {typeOfVisit && (
                  <Col xs={12} md={6} className="activity-log-margin">
                    <Label
                      for="comment"
                      className="model-comment-title mt-2 activity-level"
                    >
                      Type of Visit
                    </Label>
                    <div className="activity-log-div">
                      <ul className="ul-item task-log-value">
                        <li className="mt-1">{typeOfVisit}</li>
                      </ul>
                    </div>
                  </Col>
                )}
                {purposeOfVisit && (
                  <Col xs={12} md={6} className="activity-log-margin">
                    <Label
                      for="comment"
                      className="model-comment-title mt-2 activity-level"
                    >
                      Purpose of Visit
                    </Label>
                    <div className="activity-log-div">
                      <ul className="ul-item task-log-value">
                        <li className="mt-1">{purposeOfVisit}</li>
                      </ul>
                    </div>
                  </Col>
                )}
                {outcomeOfVisit && (
                  <Col xs={12} md={6} className="activity-log-margin">
                    <Label
                      for="comment"
                      className="model-comment-title mt-2 activity-level"
                    >
                      Outcome of Visit
                    </Label>
                    <div className="activity-log-div">
                      <ul className="ul-item task-log-value">
                        <li className="mt-1">{outcomeOfVisit}</li>
                      </ul>
                    </div>
                  </Col>
                )}
              </Row>
            ) : null}
          </div>
        ) : null}

        {taskAction &&
          (taskAction === TASK_ACTION.ASSIGN ||
            taskAction === TASK_ACTION.VIEW) && (
            <Row className="mb-5">
              <Col xs={12} md={6} className="activity-log-margin">
                <Label
                  for="comment"
                  className="model-comment-title mt-2 activity-level"
                >
                  Activity Log
                </Label>
                <div className="activity-log-div">
                  <ul className="ul-item task-log-value">
                    {taskToViewDetails?.notes?.map((noteItem) => (
                      <li
                        className="mt-1"
                        key={noteItem?.notesId ?? noteItem?.notesid}
                      >
                        {getNoteDate(noteItem)}
                        {noteItem.notesDescription}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              <Col xs={12} md={6} className="activity-log-margin create-input">
                <div className="mb-2">
                  <Label for="comment" className="model-comment-title mt-2">
                    Comments
                  </Label>
                  <Input
                    id="comment"
                    name="comment"
                    type="textarea"
                    value={comment}
                    maxLength={250}
                    className="rounded border model-comment-area comment-input"
                    onChange={(event) => {
                      setComment(event.target.value);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <Image
                    className="me-2 cursor-pointer"
                    src={Cancel}
                    onClick={() => {
                      setComment('');
                    }}
                  />
                  {'    '}
                  <Image
                    className="me-2 cursor-pointer"
                    src={
                      showLoader || !comment ? DisablesuccessTick : successTick
                    }
                    onClick={() => {
                      if (!(showLoader || !comment)) saveComment();
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}

        {(!taskAction || taskAction === TASK_ACTION.CREATE) && (
          <Row>
            <Col xs={12} md={6} className="create-comment-parent">
              <FormGroup className="comment-input">
                <Label for="comment" className="model-comment-title mt-2">
                  Comments
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  value={comment}
                  maxLength={250}
                  className="rounded border model-comment-area comment-input"
                  onChange={(event) => {
                    setComment(event.target.value);
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        )}

        <div className="d-flex justify-content-center bottom-button">
          {taskAction === TASK_ACTION.CREATE && (
            <Button
              variant="primary"
              className="cl-btn-primary-custom mt-2"
              disabled={showLoader}
              onClick={async () => {
                const selectedRolesData: number[] = await (
                  selectedRoles ?? []
                ).map(Number);
                createTask(
                  {
                    selectedTaskNameId,
                    selectedSource,
                    selectedEmployee,
                    locationData,
                    completionDateTime,
                    typeOfActivity,
                    comment,
                    customTaskName,
                    selectedRolesData,
                    inputValue,
                    zoneValRequired,
                    stateValRequired,
                    districtValRequired,
                  },
                  setShowLoader,
                  dispatch,
                  clearFields
                );
              }}
            >
              Create Task
            </Button>
          )}
          <Button
            variant="primary-outline"
            className={` mt-2 mx-4 ${
              taskAction !== TASK_ACTION.CREATE && 'cl-btn-primary-custom'
            }`}
            onClick={() => {
              if (taskAction === TASK_ACTION.CREATE) {
                navigateToViewListPage();
              } else if (onTaskAction)
                onTaskAction(CLICK_ACTIONS.CLOSE_VIEW_TASK);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} />
      <ImagePreviewModal
        isItUrl={true}
        isOpen={openImagePreview}
        onApproveRejectAction={() => {}}
        photoURL={selectedImageUrl}
        toggle={toggleImageModal}
      />
    </div>
  );
};

export default CreateTaskPage;
